module.exports = __webpack_public_path__ + "resources/img/login-img.f30bfc81.png";